// Components
import DatePicker from "vue2-datepicker"

// Utils
import { vuelidateUtil } from "@/utils/vuelidate-util.js"

// Mixins
import { dateMixins } from "@/app/mixins/utils/date-mixins"
import { toastMessageMixins } from "@/app/mixins/utils/toast-message-mixins.js"
import { numberFormatMixins } from "@/app/mixins/modules/number-format-mixins"
import { inputTextMixins } from "@/app/mixins/utils/input-text-mixins"

// Services
import PetOrderService from "@/app/services/main/pet-order/pet-order-service.js"
import BreedService from "@/app/services/main/breeds/breeds-service"
import PaymentAPI from "@/app/services/main/payment/payment-service.js"
import addressFinderAutocompleteService from "@/app/services/main/address-finder/address-finder-autocomplete/address-finder-autocomplete-service.js";

// Constants
import { STATUS_CODES, STATES, DOG_PURCHASE_STATUS } from "@/app/constants/constants"

export default {
	name: "DogRequestDetails",
	components: { DatePicker },
	mixins: [toastMessageMixins, numberFormatMixins, inputTextMixins, dateMixins],
	data() {
		return {
			// List
			orderDetails: null,
			payment: null,
			genderList: [
				{ name: "Male", value: "M" },
				{ name: "Female", value: "F" },
			],
			theads: [
				{ name: "Payment Method", sortLabel: null, isDesc: false, style: null },
				{ name: "Status", sortLabel: null, isDesc: false, style: null },
				{ name: "Message", sortLabel: null, isDesc: false, style: null },
				{ name: "Price", sortLabel: null, isDesc: false, style: null },
				// { name: 'Action', sortLabel: null, isDesc: false, style: null},
			],
			// Loader
			isEditAPILoading: false,
			isSubmitLoading: false,
			isPaymentLoading: false,
			// Dog Details
			dogName: "",
			breedId: "",
			breedName: "",
			breedList: [],
			birthDate: "",
			gender: "",
			colour: "",
			isBreedReviewed: true,
			// Breeder Information
			breederId: "",
			breederName: "",
			breederMobile: "",
			mobileNumberIsValid: true,
			breederEmail: "",
			pickupDate: "",
			address: "",
			companyName: "",
			//address finder
			addressList: [],
			isAddressLoading: false,
			// Prices
			storeCredit: 0.0,
			price: "0.00",
			// Other fields
			notes: "",
			updateStatus: "",
			state: "",
			stateOptions: [
				{
					value: "NSW",
					name: "New South Wales",
				},
				{
					value: "VIC",
					name: "Victoria",
				},
				{
					value: "QLD",
					name: "Queensland",
				},
				{
					value: "WA",
					name: "Western Australia",
				},
				{
					value: "SA",
					name: "South Australia",
				},
				{
					value: "TAS",
					name: "Tasmania",
				},
				{
					value: "NT",
					name: "Northern Territory",
				},
				{
					value: "ACT",
					name: "Australian Capital Territory",
				},
			],
			refundRemarks: "",
			image: require("@/assets/images/_shared/dog-confirm.png"),
			disableUpdateDetailsBtn: true,

			//Temporary data for comparison
			tmpdogName: "",
			tmpbirthDate: "",
			tmpgender: "",
			tmpcolour: "",
			tmpbreedId: "",
			tmpbreederId: "",
			tmpbreederName: "",
			tmpbreederMobile: "",
			tmpbreederEmail: "",
			tmppickupDate: "",
			tmpstate: "",
			tmpprice: "",
			tmpnotes: "",
			tmpcompanyName: "",
			tmpaddress: "",

		}
	},
	computed: {
		validationRules() {
			let fields = {
				breederId: {},
				breederName: {},
				breederMobile: {},
				breederEmail: {},
				breedId: {},
				price: {},
				notes: {},
				address: {},
				state: {},
				companyName: {},
			}

			fields = vuelidateUtil.setRequiredValidation(fields, "breedId")
			fields = vuelidateUtil.setRequiredValidation(fields, "breederId")
			fields = vuelidateUtil.setRequiredValidation(fields, "breederName")
			fields = vuelidateUtil.setRequiredValidation(fields, "breederMobile")
			fields = vuelidateUtil.setRequiredValidation(fields, "price")
			fields = vuelidateUtil.setMinValueValidation(fields, "price", 0)
			fields = vuelidateUtil.setRequiredValidation(fields, "breederEmail")
			fields = vuelidateUtil.setEmailValidation(fields, "breederEmail")
			fields = vuelidateUtil.setRequiredValidation(fields, "address");
			fields = vuelidateUtil.setRequiredValidation(fields, "state");
			fields = vuelidateUtil.setRequiredValidation(fields, "companyName");
			if (this.updateStatus !== "I") {
				fields = vuelidateUtil.setRequiredValidation(fields, "notes")
			}

			return fields
		},
		timelineItems() {
			let items = []
			if (this.orderDetails && this.orderDetails.transactionHistory) {
				for (const data of this.orderDetails.transactionHistory) {
					const { date, status, remarks, submittedBy } = data

					let transDate = this.formatDateTime(date)
					let content = DOG_PURCHASE_STATUS[status] ? DOG_PURCHASE_STATUS[status] : status
					if (status === "RR" && remarks && remarks != "") {
						content += `<br> <p class="color-warning mb-0">Reason: ${remarks}</p>`
						content += `<p class="color-warning mb-0">Submitted By: ${submittedBy}</p>`
						this.refundRemarks = remarks
					} else if (status === "DISAPPROVED_REFUND" && submittedBy) {
						// DISAPPROVED REFUND
						content += `<br> <p class="color-warning mb-0">Reason: ${remarks}</p>`
						content += `<p class="color-warning mb-0">Verified By: ${submittedBy}</p>`
					} else if (status === "R" && remarks && remarks != "") {
						content += `<br> <p class="color-warning mb-0">${remarks}</p>`
						content += `<p class="color-warning mb-0">Approved By: ${submittedBy}</p>`
					} else if (status === "FP" && remarks && remarks != "") {
						content += `<br> <p class="color-warning mb-0">${remarks}</p>`
						content += `<p class="color-warning mb-0">Updated By: ${submittedBy}</p>`
					} else if (submittedBy && submittedBy != "") {
						content += `<br> <p class="color-warning mb-0">Updated By: ${submittedBy}</p>`
					}

					items.push({
						htmlMode: true,
						content: `[${transDate}] : ${content}`,
					})
				}
			}

			return items.reverse()
		},
		showActionButton() {
			return this.orderDetails && this.orderDetails.status === "PR"
		},
		showApproveDisapproveRefundButton() {
			return this.orderDetails && this.orderDetails.status === "RR"
		},
		totalPrice() {
			return parseFloat(this.storeCredit) + parseFloat(this.price)
		},
		disableDogPrice() {
			const status = this.orderDetails.status
			return status != "A" && status != "DA" && status != "PR" && status != "PP" && status != "CR"
		},
	},
	watch: {
		$route: {
			handler() {
				this.getDogPurchaseDetails(this.$route.params.id, this.$route.query.token)
			},
			deep: true,
		},
		dogName(val) {
			this.disableUpdateDetailsBtn = val === this.tmpdogName
		},
		breedId(val) {
			this.disableUpdateDetailsBtn = val === this.tmpbreedId
		},
		birthDate(val) {
			this.disableUpdateDetailsBtn = val === this.tmpbirthDate
		},
		gender(val) {
			const newVal = val ? val : ""
			this.disableUpdateDetailsBtn = newVal && newVal.name === this.tmpgender.name
		},
		colour(val) {
			this.disableUpdateDetailsBtn = val === this.tmpcolour
		},
		breederId(val) {
			this.disableUpdateDetailsBtn = val === this.tmpbreederId
		},
		breederName(val) {
			this.disableUpdateDetailsBtn = val === this.tmpbreederName
		},
		breederEmail(val) {
			this.disableUpdateDetailsBtn = val === this.tmpbreederEmail
		},
		breederMobile(val) {
			this.disableUpdateDetailsBtn = val.replace("-", "") === this.tmpbreederMobile
		},
		state(val) {
			const newVal = val ? val : ""
			this.disableUpdateDetailsBtn = newVal && newVal.name === this.tmpstate.name
		},
		pickupDate(val) {
			this.disableUpdateDetailsBtn = val && this.formatDate(val) === this.formatDate(this.tmppickupDate)
		},
		price(val) {
			this.disableUpdateDetailsBtn = val === this.tmpprice
		},
		notes(val) {
			this.disableUpdateDetailsBtn = val === this.tmpnotes
		},
		address(val) {
			this.disableUpdateDetailsBtn = val === this.tmpaddress
		},
		companyName(val) {
			this.disableUpdateDetailsBtn = val === this.tmpcompanyName
		},
	},
	async created() {
		await this.getBreedList()
		await this.getDogPurchaseDetails(this.$route.params.id, this.$route.query.token)
	},
	methods: {
		onBlur(field) {
            this.$v[field].$touch();
        },
		createOptionBreed(breed) {
			this.addedBreedName = breed
			return { name: breed, id: `0-${breed}` }
		},
		setSelected(e) {
			if (!e) {
				// To trigger the validation
				// this.$v.breedId.$touch();
				this.breedId = ""
				this.breedName = ""
				return
			}
			this.breedId = e.id
			this.breedName = e.name
		},
		getBreedList() {
			BreedService.getBreeds().then((res) => {
				if (res.status === STATUS_CODES.SUCCESS) {
					this.breedList = res.data.data
				} else {
					const { ERROR_GET_BREED_LIST } = this.toastMessages.breed()
					this.showAPIErrorToast(ERROR_GET_BREED_LIST, res)
				}
			})
		},
		getDogPurchaseDetails(referenceId, token) {
			this.isEditAPILoading = true
			PetOrderService.getDogPurchase({ f_referenceId: referenceId, f_token: token })
				.then((res) => {
					if (res.status === STATUS_CODES.SUCCESS) {
						this.orderDetails = res.data
						this.payment = res.data.payment.map((dt, idx) => {
							return { ...dt, index: idx }
						})
						this.setFieldData(res.data)
					}
				})
				.finally(() => {
					this.isEditAPILoading = false
				})
		},
		setFieldData(data) {
			// Dog Details
			this.dogName = data.dogName
			this.breedName = data.name
			this.breedId = data.breedId
			this.birthDate = data.birthdate ? new Date(data.birthdate.replace(/-/g, "/")) : data.birthdate
			this.gender =
				data.gender === ""
					? ""
					: data.gender === "M"
					? { name: "Male", value: "M" }
					: { name: "Female", value: "F" }
			this.colour = data.colour
			this.isBreedReviewed = data.isBreedReviewed

			// Breeder Information
			this.breederId = data.breederId
			this.breederName = data.breederName
			this.breederEmail = data.breederEmail
			this.address = data.address
			this.companyName = data.companyName
			this.pickupDate = data.pickupDate ? new Date(data.pickupDate.replace(/-/g, "/")) : data.pickupDate
			this.state = data.state === "" || !data.state ? "" : { value: data.state, name: STATES[data.state] }

			let tempMobile = ""
			if (data.breederMobile) {
				tempMobile = data.breederMobile.split("")
				tempMobile.splice(4, 0, "-")
			}
			this.breederMobile = tempMobile.join("")

			// Prices
			this.storeCredit = data.storeCredit
			this.price = data.dogPrice
			this.notes = data.note

			//Reserve fields for comparison
			this.tmpdogName = data.dogName
			this.tmpbirthDate = data.birthdate ? new Date(data.birthdate.replace(/-/g, "/")) : data.birthdate
			this.tmpgender =
				data.gender === ""
					? ""
					: data.gender === "M"
					? { name: "Male", value: "M" }
					: { name: "Female", value: "F" }
			this.tmpcolour = data.colour
			this.tmpbreedId = data.breedId

			this.tmpbreederId = data.breederId
			this.tmpbreederName = data.breederName
			this.tmpbreederMobile = data.breederMobile
			this.tmpbreederEmail = data.breederEmail
			this.tmppickupDate = data.pickupDate ? new Date(data.pickupDate.replace(/-/g, "/")) : data.pickupDate
			this.tmpstate = data.state === "" || !data.state ? "" : { value: data.state, name: STATES[data.state] }
			this.tmpaddress = data.address
			this.tmpcompanyName = data.companyName
			this.tmpprice = data.dogPrice
			this.tmpnotes = data.note
		},
		notPastDate(date) {
			return date > new Date().setHours(0, 0, 0, 0)
		},
		notBeforeToday(date) {
			return date < new Date()
		},
		checkFormat() {
			this.$v.breederMobile.$touch()

			let regexp = /^\d{4}-\d{6}$/

			if (this.breederMobile !== null && this.breederMobile !== "") {
				this.mobileNumberIsValid = regexp.test(this.breederMobile)
			} else {
				this.mobileNumberIsValid = true
			}
		},
		showEmail(email) {
			if (email) {
				window.location.href = `mailto:${email}`
			}
		},
		onApprovedDisapproved(status) {
			this.$v.$touch()

			if (this.$v.$invalid) {
				return
			}

			const statusText = status === "APPROVED" ? "APPROVE" : "DISAPPROVE"
			this.$swal({
				title: `${statusText} REQUEST`,
				html: `<strong style="color: ${
					status === "APPROVED" ? "#1e7e34" : "#f5365c"
				}">${statusText}</strong> dog purchase of ${this.orderDetails.recipientName}?`,
				confirmButtonText: statusText,
				showCancelButton: true,
				cancelButtonText: "Cancel",
				reverseButtons: true,
				showCloseButton: true,
			}).then((result) => {
				if (result.value) {
					const dogRequestDetails = {
						status,
						referenceNumber: this.orderDetails.referenceNumber,
						token: this.orderDetails.token,
						note: this.notes,
						dogDetails: {
							breedName: this.breedName,
							breedId: this.breedId,
							gender: this.gender ? this.gender.value : "",
							colour: this.colour,
							birthDate: this.formatDate(this.birthDate),
							dogPrice: parseFloat(this.price),
							petId: this.orderDetails.petId,
							reviewed: this.isBreedReviewed,
						},
						breeder: {
							breederIdentifier: this.orderDetails.breederIdentity,
							breederName: this.breederName,
							breederId: this.breederId,
							breederMobile: this.breederMobile.replace("-", ""),
							breederEmail: this.breederEmail,
							pickupDate: this.formatDate(this.pickupDate),
							state: this.state.value,
							address: this.address,
							companyName: this.companyName
						},
					}
					this.isSubmitLoading = true

					PetOrderService.dogPurchaseApprovedDisapproved(dogRequestDetails)
						.then((res) => {
							if (res.status === STATUS_CODES.SUCCESS) {
								this.showCustomSuccessToast(null, `Dog request has been ${status.toLowerCase()}!`)
								this.getDogPurchaseDetails(this.$route.params.id, this.$route.query.token)

								// TODO: Refresh count of pending request
								// EventBus.$emit('getDogPurchaseCount');
							} else {
								this.showAPIErrorToast(`Unable to ${status.toLowerCase()} this request.`, res)
							}
						})
						.catch(() => {
							this.showGenericErrorToast()
						})
						.finally(() => {
							this.isSubmitLoading = false
						})
				}
			})
		},
		mobileNumberFormat(event) {
			this.$v.breederMobile.$touch()
			this.mobileNumberIsValid = true

			let regexp = /^\d+$/

			let updateData = regexp.test(event.target.value.charAt(event.target.value.length - 1))

			if (updateData && event.target.value.length <= 11) {
				if (event.target.value.length === 5) {
					let data = event.target.value.split("")
					if (event.target.value.charAt(4) === "-") {
						data.splice()
					} else {
						data.splice(4, 0, "-")
					}
					data = data.join("")

					this.breederMobile = data
				} else {
					this.breederMobile = event.target.value
				}
			} else {
				this.breederMobile = event.target.value.slice(0, -1)
			}
		},
		mobileFormat(mobileNumber) {
			if (mobileNumber) {
				let data = mobileNumber.split("")
				data.splice(4, 0, "-")
				return data.join("")
			} else {
				return ""
			}
		},
		updateDetails() {
			this.$v.$touch()

			if (this.$v.$invalid) {
				return
			}
			const dogRequestDetails = {
				note: this.notes,
				dogDetails: {
					breedName: this.breedName,
					breedId: this.breedId,
					gender: this.gender ? this.gender.value : "",
					colour: this.colour,
					birthDate: this.formatDate(this.birthDate),
					dogPrice: parseFloat(this.price),
				},
				breeder: {
					breederIdentifier: this.orderDetails.breederIdentity,
					breederName: this.breederName,
					breederId: this.breederId,
					breederMobile: this.breederMobile.replace("-", ""),
					breederEmail: this.breederEmail,
					pickupDate: this.formatDate(this.pickupDate),
					state: this.state.value,
					address: this.address,
					companyName: this.companyName
				},
			}

			this.isSubmitLoading = true
			PetOrderService.updateDogPurchaseDetails(dogRequestDetails, this.orderDetails.referenceNumber)
				.then((res) => {
					if (res.status === STATUS_CODES.SUCCESS_NO_CONTENT) {
						this.showCustomSuccessToast(null, `Dog request has been updated!`)
						this.getDogPurchaseDetails(this.$route.params.id, this.$route.query.token)
					} else {
						this.showAPIErrorToast(`Unable to ${status.toLowerCase()} this request.`, res)
					}
				})
				.catch(() => {
					this.showGenericErrorToast()
				})
				.finally(() => {
					this.isSubmitLoading = false
				})
		},
		submitApproval() {
			const paymentMethod = this.orderDetails.payment.filter(
				(dt) => dt.status === "PROCESSED" || dt.status === "COMPLETED" || dt.status === "APPROVED"
			)
			let modalContent = `<div class="d-flex align-items-center flex-column">`
			modalContent += `<p class="mb-0 my-2" style="color: fd7e14">Are you sure you want to approve the request for refund?</p>`
			modalContent += `<p class="mb-3"><span class="font-weight-bold">${paymentMethod[0].name.toUpperCase()}</span>: $${
				paymentMethod[0].price
			}</p>`
			modalContent += `<p class="mb-0">Enter Refund Amount:</p>`
			modalContent += "</div>"
			this.$swal({
				titleText: "Request For Refund",
				html: modalContent,
				confirmButtonText: "Confirm",
				showCancelButton: true,
				cancelButtonText: "Cancel",
				reverseButtons: true,
				input: "number",
				showCloseButton: true,
				customClass: {
					input: "mt-1 refund-input",
				},
				inputAttributes: {
					min: 1,
				},
				inputValidator: (value) => {
					if (!value || parseFloat(value) === 0) {
						return "Please enter refund amount"
					}

					if (parseFloat(value) > parseFloat(paymentMethod[0].price)) {
						return "Refund amount should not be greater than ordered price"
					}

					if (parseFloat(value) < 0) {
						return "Refund amount should not be negative"
					}
				},
			}).then((result) => {
				if (result.value) {
					const requestDetails = {
						status: "APPROVED",
						referenceNumber: this.orderDetails.referenceNumber,
						amount: result.value,
					}

					this.processApprovedRefund(requestDetails)
				}
			})
		},
		async submitDisapproval() {
			const { value: remarks } = await this.$swal({
				titleText: `Reason For Disapproval`,
				html: `<div style="margin:2rem"><img src=${this.image} style="" height="200"></div><p>Are you sure you want to disapprove this request? Please state your reason in the textbox below.</p>`,
				input: "textarea",
				inputPlaceholder: "Type your reason here...",
				inputAttributes: {
					"aria-label": "Type your reason here",
				},
				confirmButtonText: "Confirm",
				showCancelButton: true,
				cancelButtonText: "Cancel",
				reverseButtons: true,
				inputValidator: (remark) => {
					if (!remark) {
						return "You must input a reason for disapproval!"
					}
				},
			})

			if (remarks) {
				const requestDetails = {
					status: "DISAPPROVED",
					referenceNumber: this.orderDetails.referenceNumber,
					remarks: remarks,
				}

				this.processRefund(requestDetails)
			}
		},

		processRefund(requestDetails) {
			this.isSubmitLoading = true
			PetOrderService.dogPurchaseApprovedDisapprovedRefund(requestDetails)
				.then((res) => {
					if (res.status === STATUS_CODES.SUCCESS) {
						this.showCustomSuccessToast(
							null,
							`Successfully ${requestDetails.status.toLowerCase()} the request for refund.`
						)
						this.getDogPurchaseDetails(this.orderDetails.referenceNumber, this.orderDetails.token)
					} else {
						this.showAPIErrorToast(ERROR_APPROVE_CANCELLATION, res)
					}
				})
				.catch(() => {
					this.showGenericErrorToast()
				})
				.finally(() => {
					this.isSubmitLoading = false
				})
		},

		processApprovedRefund(requestDetails) {
			this.isSubmitLoading = true
			PetOrderService.dogPurchaseApprovedRefund(requestDetails)
				.then((res) => {
					if (res.status === STATUS_CODES.SUCCESS) {
						this.showCustomSuccessToast(
							null,
							`Successfully ${requestDetails.status.toLowerCase()} the request for refund.`
						)
						this.getDogPurchaseDetails(this.orderDetails.referenceNumber, this.orderDetails.token)
					} else {
						this.showAPIErrorToast(ERROR_APPROVE_CANCELLATION, res)
					}
				})
				.catch(() => {
					this.showGenericErrorToast()
				})
				.finally(() => {
					this.isSubmitLoading = false
				})
		},

		submitApprovedDisapprovedBreed(status) {
			this.isSubmitLoading = true
			const requestDetails = {
				status,
				breedId: this.breedId,
				dogPurchaseId: this.orderDetails.id,
			}
			PetOrderService.dogPurchaseApprovedDisapprovedBreed(requestDetails)
				.then((res) => {
					if (res.status === STATUS_CODES.SUCCESS) {
						this.showCustomSuccessToast(null, `Successfully ${status.toLowerCase()} the new breed.`)
						this.getDogPurchaseDetails(this.orderDetails.referenceNumber, this.orderDetails.token)
					} else {
						this.showAPIErrorToast(ERROR_APPROVE_CANCELLATION, res)
					}
				})
				.finally(() => {
					this.isSubmitLoading = false
				})
		},
		processPendingPayment(data) {
			this.$swal({
				title: "Update Payment",
				text: `Was the client payment successful or unsuccessful?`,
				confirmButtonText: "Successful",
				showCancelButton: true,
				cancelButtonText: "Unsuccessful",
				reverseButtons: true,
				showCloseButton: true
			}).then((result) => {

				if (!result.dismiss || (result.dismiss !== 'close' && 
						result.dismiss !== 'backdrop')) {
					let status = result.value ? 'APPROVED' : '';

					if (result.dismiss === 'cancel') {
						status = 'CANCELLED'
					}
					this.isPaymentLoading = true
					PaymentAPI.dogPurchaseManualProcessPendingPayment(this.orderDetails.id, data.id, status)
						.then((res) => {
							if (res.status === STATUS_CODES.SUCCESS) {
								if (res.data.status === "PENDING") {
									this.showCustomSuccessToast(null, res.data.message)
								} else {
									this.showCustomSuccessToast(null, `Successfully updated the payment status.`)
								}
								this.getDogPurchaseDetails(this.$route.params.id, this.$route.query.token)
							} else {
								this.showAPIErrorToast(`Failed to update the payment status.`, res)
							}
						})
						.catch(() => {
							this.showGenericErrorToast()
						})
						.finally(() => {
							this.isPaymentLoading = false
						})
				}
			})
		},

		async onBlur(field) {
			if (field === "address") {
				this.$v.address.$touch();
	
				if (this.address) {
					await this.getAddressMetaData(this.address);
				}
			}
		},
	
		findAddress(address) {
			if (address) {
				this.isAddressLoading = true;
	
				this.delayTyping(() => {
					this.getAutocompleteAddress(address);
				});
			}
		},
	
		getAutocompleteAddress(address) {
			addressFinderAutocompleteService
				.getAutocompleteAddress(address)
				.then((res) => {
					if (res.status === STATUS_CODES.SUCCESS) {
						this.addressList = res.data.completions.map((item) => {
							let tempAddress = item.full_address;
							item.displayAddress = tempAddress;
							item.label = item.id;
							return item;
						});
						this.isAddressLoading = false;
					} else {
						const { ERROR_GET_ADDRESS } = this.toastMessages.addressFinder();
						this.showAPIErrorToast(ERROR_GET_ADDRESS, res);
						this.isAddressLoading = false;
					}
				})
				.catch(() => {
					this.showGenericErrorToast();
					this.isAddressLoading = false;
				});
		},
	
		async getAddressMetaData(address) {
			addressFinderAutocompleteService
				.getAddressMetaData(address.id)
				.then((res) => {
					if (res.status === STATUS_CODES.SUCCESS) {
						const { locality_name, postcode } = res.data;
						this.address = locality_name + " " + postcode;
					} else {
						const { ERROR_GET_ADDRESS } = this.toastMessages.addressFinder();
						this.showAPIErrorToast(ERROR_GET_ADDRESS, res);
						this.isAddressLoading = false;
					}
				})
				.catch(() => {
					this.showGenericErrorToast();
					this.isAddressLoading = false;
				});
		},
		async setSelectedAddress() {
			this.$v.address.$touch();
	
			if (this.address) {
				await this.getAddressMetaData(this.address);
			}
		},
	},
	// third party libraries
	validations() {
		return this.validationRules
	},
}
